import { teachList, addTeachOrder, calcTeachOrder } from '@/api'
import { failMsg } from '@/libs/utils'
import { Loading } from 'element-ui'
const state = {
    teach: [],
    teachOrder: {},
    teachOrderTotal: {},
}

const actions = {
    // 获取教学列表
    async getTeachList({ commit }, context) {
        try {
            let data = await teachList(context)
            data.data.forEach(item => {
                item.teachTitle = item.name.split(' ')
                item.detailDescribe = item.description.split('\n')
            })
            commit('GETTEACHLIST', data.data)
        } catch (error) {
            failMsg(error)
        }
    },
    // 创建教学订单
    async addTeachOrder({ commit }, context) {
        Loading.service({
            lock: false,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
            customClass: 'orderLoading',
        })
        try {
            let data = await addTeachOrder(context)
			Loading.service().close()
            commit('ADDTEACHORDER', data)
            if (data.result) {
                location.href = data.data
                return Promise.resolve()
            }
        } catch (error) {
            failMsg(error)
            Loading.service().close()
            return new Promise.reject()
        }
    },
    // 计算教学订单金额
    async calcTeachOrder({ commit }, context) {
        try {
            let data = await calcTeachOrder(context)
            commit('CALCTEACHORDER', data.data)
        } catch (error) {
            return new Promise.reject()
        }
    },
}

const mutations = {
    GETTEACHLIST(state, params) {
        state.teach = params
    },
    ADDTEACHORDER(state, params) {
        state.teachOrder = params
    },
    CALCTEACHORDER(state, params) {
        state.teachOrderTotal = params
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
